"use client";

import React from "react";
import { PortalLayout } from "@shesha-io/pd-publicportal";
import {
  ConfigurableForm,
  FormFullName,
  PageWithLayout,
} from "@shesha-io/reactjs";

const HOME_PAGE_CONFIGURATION: FormFullName = {
  name: "home-page",
  module: "boxfusion.dsdnpo",
};

const Home: PageWithLayout = () => (
  <PortalLayout>
    <ConfigurableForm mode={"readonly"} formId={HOME_PAGE_CONFIGURATION} />
  </PortalLayout>
);

export default Home;
